import styled from 'styled-components';

export const Wrapper = styled.div`
    width: 270px;
    font-size: 16px;
    padding-bottom: 15px;
`;

export const ListItem = styled.li`
    text-align: left;
    cursor: default;
    border-top: 1px solid var(--color-border-500);

    &:first-child {
        border-color: transparent;
    }

    svg {
        font-size: 18px;
        margin-right: 15px;
        color: var(--color-text-300);
    }

    > a,
    > span {
        display: block;
        padding: 15px 30px;
        color: var(--color-text-500);

        &:not([disabled]) {
            cursor: pointer;

            &:hover {
                text-decoration: none;
                color: var(--color-primary-500);

                svg {
                    color: var(--color-primary-500);
                }
            }
        }

        &[disabled] {
            opacity: 0.4;
            cursor: not-allowed;
        }
    }
`;

export const Badge = styled.span``;
